var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomFieldPicker = function SvgCustomFieldPicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2739_500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8449 11.0117C17.2608 10.2092 17.4999 9.3 17.4999 8.33333C17.4999 5.11167 14.8883 2.5 11.6666 2.5C10.6999 2.5 9.79078 2.73917 8.98828 3.155",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 17.5002C5.11083 17.5002 2.5 14.8877 2.5 11.6668C2.5 8.446 5.11083 5.8335 8.33333 5.8335C11.5542 5.8335 14.1667 8.446 14.1667 11.6668C14.1667 14.8877 11.5542 17.5002 8.33333 17.5002Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9259 10.3706L7.68503 13.6114L5.7417 11.6664",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2739_500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgCustomFieldPicker as ReactComponent };
export default __webpack_public_path__ + "custom-field-picker.svg";